import type { ErrorType } from '~/data/ErrorRecord';
import type { TechnicalDataCategory } from '~/data/TechnicalData';

export const initialState: Fields = {
  isLoading: false,
  categories: [],
  error: undefined,
};

interface Fields {
  isLoading: boolean;
  categories: TechnicalDataCategory[];
  error?: ErrorType;
}
